/* unplugin-vue-components disabled */import { render } from "./ImageCarousel.vue?vue&type=template&id=0a258b15&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=0a258b15&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a258b15"]])

export default __exports__